import styled from "@emotion/styled";
import { surface, shadow, zIndex, spacing, fontSize, border as borderToken } from "@atlas-int/tokens";

/** Base CSS-only tooltip styles (shared across arrow variants) */
const tooltipBase = `
  font-size: ${fontSize.xs};
  background-color: ${surface.white};
  text-align: center;
  padding: ${spacing[2]};
  box-sizing: border-box;
  z-index: ${zIndex.navigation};
  border: 1px solid ${borderToken.subtle};
  box-shadow: ${shadow.sm};
`;

/**
 * Tooltip that appears above a relatively-positioned parent,
 * with an arrow pointing down.
 */
export const TooltipAbove = styled.div`
  ${tooltipBase}
  position: absolute;
  top: -90%;
  left: 0px;
  margin-bottom: 100px;
  width: 100%;

  &::before {
    content: "";
    position: absolute;
    top: 100%;
    left: calc(50% - 11px);
    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-top: 11px solid ${borderToken.subtle};
  }

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: calc(50% - 10px);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${surface.white};
  }
`;

/**
 * Tooltip that appears to the right of a positioned parent,
 * with an arrow pointing left.
 */
export const TooltipRight = styled.div`
  ${tooltipBase}
  position: fixed;
  left: 70px;
  white-space: nowrap;

  &::before {
    content: "";
    position: absolute;
    left: -11px;
    top: calc(50% - 6px);
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 11px solid ${borderToken.subtle};
  }

  &::after {
    content: "";
    position: absolute;
    left: -10px;
    top: calc(50% - 5px);
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 10px solid ${surface.white};
  }
`;
